import { render, staticRenderFns, recyclableRender, components } from "./u-navbar.vue?vue&type=template&id=75dad532&scoped=true&"
var renderjs
import script from "./u-navbar.vue?vue&type=script&lang=js&"
export * from "./u-navbar.vue?vue&type=script&lang=js&"
import style0 from "./u-navbar.vue?vue&type=style&index=0&id=75dad532&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dad532",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-navbar/u-navbar.vue"
export default component.exports